import * as React from 'react';
import { css } from 'aphrodite/no-important';
import { imageStyle } from '../image.utils';
import { CalculatedThumbnail } from '../image.types';

export const EagerImage: React.FunctionComponent<CalculatedThumbnail> = props => {
  const { imageUrl, srcSet, sizes, alt, title } = props;
  return (
    <img
      className={css(imageStyle.base)}
      srcSet={srcSet}
      sizes={sizes}
      src={imageUrl}
      alt={alt}
      title={title}
    />
  );
};
